import { render, staticRenderFns } from "./product-slider.vue?vue&type=template&id=2ec4aa42&scoped=true&"
import script from "./product-slider.vue?vue&type=script&lang=js&"
export * from "./product-slider.vue?vue&type=script&lang=js&"
import style0 from "./product-slider.vue?vue&type=style&index=0&id=2ec4aa42&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec4aa42",
  null
  
)

export default component.exports